import activePage from './active-page';
import ownerId from './owner-id';
import pageHasGlobals from './page-has-globals';
import pageHTML from './page-html';
import pages from './pages';
import pageUsedBlocks from './page-used-blocks';
import session from './session';
import settings from './settings';
import siteId from './site-id';
import siteName from './site-name';
import siteProperties from './site-properties';
import pageSettings from './page-settings';
import multilingual from './multilingual';
import updatedAt from './updated-at';
import usedCustomColors from './used-custom-colors';
import lastAppliedMigrationId from './last-applied-migration-id';
import cleanUrlsEnabled from './clean-urls-enabled';
import redirects from './redirects';
import integrations from './integrations';

export default {
  activePage,
  ownerId,
  pageHasGlobals,
  pageHTML,
  pages,
  pageUsedBlocks,
  session,
  settings,
  siteId,
  siteName,
  siteProperties,
  pageSettings,
  multilingual,
  updatedAt,
  usedCustomColors,
  lastAppliedMigrationId,
  cleanUrlsEnabled,
  redirects,
  integrations,
};
